<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <form class="text-edit-dialog-form">
    <mat-form-field style="width: 100%">
      <mat-label>{{ data.prompt }}</mat-label>
      <input
        matInput
        name="CurrentData"
        [(ngModel)]="CurrentData"
      /> </mat-form-field
    ><br />
  </form>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="piButton"
    (click)="onConfirmClick()"
    cdkFocusInitial
  >
    Confirm
  </button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">
    Cancel
  </button>
</div>
